module.exports = __webpack_public_path__ + "static/media/icon_save_saved.4edd9cda.svg";